import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Department } from 'src/app/models/department.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentService } from 'src/app/services/department.service';

export class DepartmentsSummary {
  constructor(
    public departmentName: string,
    public orderBacklog: number,
    public budget: number,
    public orderBacklogMonths: number,
  ) {

  }
}

export class DepartmentEstimatedProfit {
  constructor(
    public departmentName: string,
    public estimateProfitAfterExpenses: number,
  ) {

  }
}

@Component({
    selector: 'app-departments-summary',
    imports: [
        DecimalPipe
    ],
    templateUrl: './departments-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './departments-summary.component.scss'
})
export class DepartmentsSummaryComponent implements OnInit, OnChanges {
  @Input() public year: Date;
  @Input() public includePipeline: boolean = false;
  @Input() public departmentId: string | null = null;

  private departmentsSummaryEksl: DepartmentsSummary[] = [];
  private departmentsSummaryInkl: DepartmentsSummary[] = [];
  private estimateProfitEksl: DepartmentEstimatedProfit[] = [];
  private estimateProfitInkl: DepartmentEstimatedProfit[] = [];

  constructor(
    private dashboardService: DashboardService,
  ) {

  }

  public get departmentsSummary(): DepartmentsSummary[] {
    return this.includePipeline ? this.departmentsSummaryInkl : this.departmentsSummaryEksl;
  }

  public get estimateProfitAfterExpenses(): DepartmentEstimatedProfit[] {
    return this.includePipeline ? this.estimateProfitInkl : this.estimateProfitEksl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const yearChanged = changes['year'] && changes['year'].currentValue && !changes['year'].firstChange;
    const departmentChanged = changes['departmentId'] && !changes['departmentId'].firstChange;
    if (yearChanged || departmentChanged) {
      this.ngOnInit();
    }
  }

  async ngOnInit(): Promise<void> {
    const year = this.year.getFullYear();
    [this.departmentsSummaryEksl, this.departmentsSummaryInkl, this.estimateProfitEksl, this.estimateProfitInkl] = await Promise.all([
      this.dashboardService.departmentsSummary(year, false, this.departmentId),
      this.dashboardService.departmentsSummary(year, true, this.departmentId),
      this.dashboardService.estimatedProfitAfterExpenses(year, false, this.departmentId),
      this.dashboardService.estimatedProfitAfterExpenses(year, true, this.departmentId),
    ]);
  }
}
